import { SettingsGroup } from "./types";

/** Versa (productId = 6) — mirrors the sample template Excel file groupings. */
export const versaSettingsGroups: SettingsGroup[] = [
  { label: "Settings2", screens: ["Tax Exempt Categories", "Market Segment"] },
  {
    label: "Settings3",
    screens: [
      "Origins",
      "Pickup and DropOff Code",
      "Preference Categories",
      "Guest Type",
      "Special Arrangement Code",
      "Special Guarantee Code",
      "Terminal Code",
      "Vehicle Code",
      "Vip Type",
    ],
  },
  {
    label: "Settings5",
    screens: ["Room Feature", "Room Location", "Department"],
  },
  { label: "Settings6", screens: ["Segment 1", "Building", "Category"] },
  { label: "Settings7_TaxPostType", screens: ["Tax Post Type"] },
  { label: "Settings7_Tax", screens: ["Tax"] },
  { label: "Settings7", screens: ["Segment 2", "Post Type"] },
  {
    label: "Settings7_RoomTypeMaintenance",
    screens: ["Room Type Maintenance"],
  },
  { label: "Settings8", screens: ["HouseKeeping Sections"] },
  //{ label: "Settings9", screens: ["Payment Method"] },
  { label: "Settings10_RoomDefinition", screens: ["Room Definition"] },
];
